module.exports = __webpack_public_path__ + "img/61.38609af0.jpg";